import React, { memo } from "react";
import { Typography } from "@progress/kendo-react-common";
import { FieldArray, FormRenderProps } from "@progress/kendo-react-form";
import ShadowCard from "../../../components/common/ShadowCard";
import B2BTourItineraryArray from "./B2BTourItineraryArray";
import IconComponent from "../../../components/common/IconComponent";
import { FaRoute } from "react-icons/fa";

interface B2BTourItinerarySectionProps {
  formRenderProps: FormRenderProps;
}

const B2BTourItinerarySection: React.FC<B2BTourItinerarySectionProps> = ({
  formRenderProps
}) => {
  return (
    <ShadowCard className="b2b-quotation-module b2b-card mb-4 p-0">
      <div className="p-4 d-flex gap-3 align-items-start border-bottom border-light">
        <div className="hotel-icon-wrap shadow-sm">
          <IconComponent icon={FaRoute} />
        </div>
        <div className="flex-grow-1">
          <div className="d-flex align-items-center gap-2">
            <Typography.h5 className="section-title mb-0">Tour Itinerary</Typography.h5>
          </div>
          <Typography.p className="section-subtitle mb-0 mt-1" style={{ fontSize: "13px" }}>
            Plan the day-by-day journey. Select a city and choose from existing itineraries or create custom descriptions for each day.
          </Typography.p>
        </div>
      </div>

      <div className="p-4">

        <div className="mt-4">
          <FieldArray
            name="Itinary"
            component={B2BTourItineraryArray}
            formRenderProps={formRenderProps}
          />
        </div>
      </div>
    </ShadowCard>
  );
};

export default memo(B2BTourItinerarySection);
